import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DiaryNoteCard } from '@/components/DiaryNotes/DiaryNoteCard';
import { DiaryNoteModal } from '@/components/DiaryNotes/DiaryNoteModal';
import type {
  DiaryBehaviourEntry,
  DiaryNote,
  DiaryNoteItem,
} from '@/types/diary';

interface Props {
  behaviourEntries: DiaryBehaviourEntry[];
  notes: DiaryNote[];
}

export const DiaryNotes: React.FC<Props> = ({ behaviourEntries, notes }) => {
  const { t } = useTranslation();
  const [openedItem, setOpenedItem] = useState<DiaryNoteItem>();

  const items: DiaryNoteItem[] = [
    ...behaviourEntries.map((entry) => ({
      ...entry,
      title: t('diary.notes.behaviourEntry'),
    })),
    ...notes.map((note) => ({
      ...note,
      title: t('diary.notes.teacherMessage'),
    })),
  ];

  if (!items.length) {
    return null;
  }

  return (
    <div>
      <p className="text-subhead-14 pt-6 pb-2 text-foreground">
        {t('home.dashboard.diary.title')}
      </p>

      <div className="flex flex-col gap-2">
        {items.map((item, index) => (
          <button
            key={index}
            type="button"
            className="group w-full cursor-pointer"
            onClick={() => setOpenedItem(item)}
          >
            <DiaryNoteCard item={item} />
          </button>
        ))}
      </div>

      {openedItem && (
        <DiaryNoteModal
          item={openedItem}
          onClose={() => setOpenedItem(undefined)}
        />
      )}
    </div>
  );
};
